import React from 'react'
import ArticleCardHome from 'Components/article_card_home'
import Shimmer from 'Components/shimmer'
import { handleUrlArticle } from 'Helpers/utils'

const MostPopular = ({ popularArticles, isMobile }) => (
  <React.Fragment>
    {popularArticles.is_loading ? (
      <div className="sidebar-content">
        <div className="row-shimmer">
          {[...Array(4).keys()].map((index) => (
            <div key={String(index)} className="col-shimmer">
              <div>
                <Shimmer height="60px" width="100%" />
              </div>
              <div>
                <Shimmer width="100%" />
                <Shimmer width="100%" />
                <Shimmer width="100%" />
              </div>
            </div>
          ))}
        </div>
      </div>
    ) : Array.isArray(popularArticles?.data) &&
      popularArticles?.data?.length > 0 ? (
      <div className="sidebar-content">
        <div className="sidebar-title-wrapper">
          <h3 className="sidebar-content-title">Most Popular</h3>
        </div>
        {popularArticles?.data?.map((item, index) => (
          <ArticleCardHome
            key={index}
            numbering={index}
            is_mobile={isMobile}
            is_sponsored={false}
            font_title={`Josefin Sans, sans-serif`}
            article={Object.assign({
              category: { name: item.category_slug },
              date: item.created_at,
              title: item.title,
              text: item.excerpt,
              image: item.image,
              url: handleUrlArticle(item.url),
              author: { fullname: item.author.name },
            })}
            type={'type-7'}
          />
        ))}
      </div>
    ) : null}
  </React.Fragment>
)

export default MostPopular
